import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import LocalStorageObject from "@/utils/storageObject";
import { getFeatureUpdateReminderApi } from "@/api/organization";
import ReactMarkdown from "react-markdown";
import { useTranslation } from "react-i18next";

export default function FeatureUpdateReminder() {
  const { t, i18n } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState<any>(null);

  const getUpdate = async () => {
    try {
      const res = await getFeatureUpdateReminderApi(i18n.language);
      const updateReminderStorage: string[] =
        LocalStorageObject.get("updateReminderStorage") || [];
      if (!res?.version) {
        return;
      }
      if (updateReminderStorage?.includes(res?.version)) {
        return;
      }
      setData(res);
      updateReminderStorage.push(res?.version);
      LocalStorageObject.set("updateReminderStorage", updateReminderStorage);
      setVisible(true);
    } catch (error) {
      console.error(error);
    }
  };

  const handleClose = () => {
    if (data?.link) {
      window.open(data?.link, "_blank");
    }
    setVisible(false);
  };

  useEffect(() => {
    getUpdate();
  }, []);

  return (
    <Modal
      title=""
      open={visible}
      closable={false}
      footer={null}
      width={520}
      styles={{
        content: { padding: 0, borderRadius: "16px", overflow: "hidden", maxHeight: "80vh" },
      }}
    >
      <div className="flex flex-col h-full max-h-[80vh]">
        {/* 可滚动的内容区域 */}
        <div className="flex-1 overflow-y-auto">
          <div className="w-full">
            {data?.image && (
              <img
                className="w-full"
                src={data?.image}
                alt="feature-update-reminder"
              />
            )}
          </div>
          <div className="p-[30px] pb-4">
            <div className="w-[458.35px] inline-flex flex-col justify-start items-center gap-3">
              <div className="w-[458.35px] text-center justify-start text-text-color-primary text-2xl font-semibold font-['DM_Sans'] leading-[32px]">
                {data?.title}
              </div>
              <div className="self-stretch text-center justify-start text-font&icon-secondary text-sm font-normal font-['DM_Sans'] leading-snug">
                <ReactMarkdown>{data?.content}</ReactMarkdown>
              </div>
            </div>
          </div>
        </div>
        
        {/* 固定在底部的按钮 */}
        <div className="p-[30px] pt-4 border-t border-gray-100 bg-white">
          <Button
            className="w-full black-button"
            size="large"
            onClick={handleClose}
          >
            {data?.buttonText || t('common.gotIt')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
